import { Switch, SwitchLabelProps, SwitchRootProps } from '@chakra-ui/react'
import { forwardRef } from 'react'

export interface Props extends Omit<SwitchRootProps, 'children' | 'onChange' | 'onCheckedChange'> {
  label?: string
  /** (default right) */
  labelPosition?: 'left' | 'right'
  labelProps?: Omit<SwitchLabelProps, 'children'>
  onChange?: (checked: boolean) => void
}

export default forwardRef<HTMLLabelElement, Props>(
  ({ label, labelPosition = 'right', labelProps, onChange, ...rest }, ref) => {
    return (
      <Switch.Root
        ref={ref}
        alignItems="center"
        cursor="pointer"
        colorPalette="primary"
        gap={2}
        onCheckedChange={p => onChange?.(p.checked)}
        {...rest}
      >
        {labelPosition === 'left' && label && <Switch.Label {...labelProps}>{label}</Switch.Label>}
        <Switch.HiddenInput />
        <Switch.Control />
        {labelPosition === 'right' && label && <Switch.Label {...labelProps}>{label}</Switch.Label>}
      </Switch.Root>
    )
  }
)
